module.exports = __webpack_public_path__ + "img/ontag-mono.36c8bf70.svg";